document.addEventListener('DOMContentLoaded', () => {
    new AuraEmailCollector().init();
});

class AuraEmailCollector {

    static ID_MAIN_DIV          = 'aura-email-capture__main';
    static CLASS_MODULE_PREFIX  = 'aura-email-capture__';
    static OUTBOUND_CLICK_DELAY = 100; // all delays are in milliseconds
    static STATUS_DISPLAY_DELAY = 1000; 

    constructor() {
        this.mainDiv = document.getElementById(AuraEmailCollector.ID_MAIN_DIV);
        this.klaviyoCompanyId = this.mainDiv.dataset.klaviyoCompanyId;
        this.klaviyoListId = this.mainDiv.dataset.klaviyoListId;
        this.klaviyoMarketingEvent = this.mainDiv.dataset.klaviyoMarketingEvent;
        this.targetSelector = this.mainDiv.dataset.targetSelector;
        this.displayOnce = this.mainDiv.dataset.displayOnce !== 'false';
        this.secondaryCta = this.mainDiv.dataset.secondaryCta === 'true';
        this.emailSubmissionText = this.mainDiv.dataset.emailSubmissionText;
        this.hooks = document.querySelectorAll(this.targetSelector); this.hooks = [...this.hooks].filter(el => !this.mainDiv.contains(el));
        this.popupCloseBtn = this.mainDiv.querySelector(`.${AuraEmailCollector.CLASS_MODULE_PREFIX}close`);
        this.emailSubmitBtns = this.mainDiv.querySelectorAll(`[class*="${AuraEmailCollector.CLASS_MODULE_PREFIX}submit-btn"]`);
        this.emailInputBox = document.getElementById(`${AuraEmailCollector.CLASS_MODULE_PREFIX}email`);
        this.statusBox = this.mainDiv.querySelector(`.${AuraEmailCollector.CLASS_MODULE_PREFIX}status`);

        this.hookClicked = false;
        this.emailSubmitted = false;
        this.pixelId = this.getPixelId();

    }

    init() {
        this.initListeners();
    }

    initListeners() {
        this.initClosePopupListeners();
        this.initControlsHooks();
        this.initEmailSubmission();
        this.initOthers();
    }
    initClosePopupListeners () {
        this.mainDiv.addEventListener('click', (e) => {
            if (e.target === this.mainDiv) {
                this.mainDiv.classList.add('hidden');
            }
        });
        this.popupCloseBtn.addEventListener('click', () => {
            this.mainDiv.classList.add('hidden');
        });
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && !this.mainDiv.classList.contains('hidden')){
                this.mainDiv.classList.add('hidden');
            }
        });
    }
    initEmailSubmission () {
        this.emailSubmitBtns.forEach((el) => {
            el.addEventListener('click', () => this.submitEmail(this.emailInputBox.value));
        });
        this.emailInputBox.addEventListener('input', () => {
            const isEmailValid = this.validateEmail(this.emailInputBox.value);
            this.emailSubmitBtns.forEach((el) => {el.disabled = !isEmailValid});
        });
    }
    initControlsHooks(){
        this.hooks.forEach((el) => {
            el.addEventListener('click', (event) => this.onHookClick(event));
        });
    }
    initOthers() {
        if (this.secondaryCta) {
            const secondaryCtaBtn = this.mainDiv.querySelector('.aura-email-capture__button');
            if (secondaryCtaBtn) {
                secondaryCtaBtn.addEventListener('click', (ev) => this.handleOutboundClick(ev));
            }
        }
    }
    onHookClick(event) {
        if (!this.hookClicked || !this.displayOnce) {
            this.hookClicked = true;
            event.preventDefault();
            this.displayPopup(event);
        }
    }
    displayPopup(event) {
        this.hookEvent = event;
        this.mainDiv.classList.remove('hidden');
    }
    resumeDefault(event) {
        event?.target?.form?.submit?.() || (event?.target?.href && (window.location.href = event.target.href));
    }
    validateEmail(email) {
        return email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
    }

    setStatus(text, status){
        this.statusBox.classList.add(status);
        this.statusBox.innerHTML = text;
    }
    hideStatus(){
        this.statusBox.innerHTML = '';
    }

    async submitEmail(email) {

        await this.submitEmailToKlaviyo(email)
        .then(() => {
            this.setStatus(this.emailSubmissionText, 'success');
            setTimeout(() => {
                console.debug(`submitEmail: ${this.hookEvent}`);
                this.handleOutboundClick(this.hookEvent, false);
            }, AuraEmailCollector.STATUS_DISPLAY_DELAY);
        })
            .catch(() => {
            this.setStatus('There was a problem submitting an email.', 'error');
            setTimeout(() => {
                this.mainDiv.classList.add('hidden');
            }, AuraEmailCollector.STATUS_DISPLAY_DELAY);
        });
    }

    async submitEmailToKlaviyo(email) {
        const companyId = this.klaviyoCompanyId;
        const listId = this.klaviyoListId;
        const marketingEvent = this.klaviyoMarketingEvent;


        if (!companyId || !listId) {
            throw new Error(`list ID ${listId} or Company ID ${companyId} cannot be empty`);
        } else if (!this.validateEmail(email)) {
            throw new Error(`email ${email} is not a valid email address`);
        }

        const res = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${companyId}`, {
            method: 'POST',
            headers: {
                accept: 'application/vnd.api+json',
                revision: '2025-07-15',
                'content-type': 'application/vnd.api+json'
            },
            body: JSON.stringify({
                data: {
                    "type": "subscription",
                    "attributes": {
                        "custom_source": marketingEvent,
                        "profile": {
                            "data": {
                                "type": "profile",
                                "attributes": {
                                    "email": email,
                                    "subscriptions": {
                                        "email": {
                                            "marketing": {
                                                "consent": "SUBSCRIBED"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    },
                    "relationships": {
                        "list": {
                            "data": {
                                "type": "list",
                                "id": listId
                            }
                        }
                    }
                }
            })
        });

        if (!res.ok) throw new Error(`Klaviyo error ${res.status}: ${await res.text()}`);
    }

    getPixelId() {
        if (window.fbq && window.fbq.getState) {
            const state = window.fbq.getState();
            if (state && state.pixels && state.pixels.length > 0) {
            return state.pixels[0].id; // first pixel ID on the page
            }
        }
        return null;
    }
    normalizeEmail(email) {
        return String(email).trim().toLowerCase();
    }
    async reportLeadCaptureEmail (rawEmail) {
        if (this.pixelId) {
            const email = this.normalizeEmail(rawEmail);
            fbq('init', this.pixelId, { em: email});
            fbq('track', 'Lead', {
                content_name: 'Quiz',
                content_category: 'quiz'
            });
        }
    }
    async reportOutboundClick (url = 'unknown') {
        if (window.fbq) {
            fbq('trackCustom', 'EmailCaptureOutboundClick', {
                destination: url,
                content_name: 'Quiz',
                content_category: 'quiz'
            });
        }
    }
    handleOutboundClick(event, preventDefault = true){
        console.debug(event);
        if (preventDefault) event.preventDefault();
        if (event.target.href) {
            this.reportOutboundClick(event.target.href);
            setTimeout(() => {
                this.resumeDefault(event);
            }, AuraEmailCollector.OUTBOUND_CLICK_DELAY);
        }
    }

}